"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateMachineCapacity = updateMachineCapacity;
async function updateMachineCapacity(machineRepo, machineId, micronAisleId, aisleCode, capacity) {
    return await machineRepo.updateMachineCapacity(machineId, micronAisleId, aisleCode, capacity);
}
